export class UrlConstants {
  static feedUrl: string;
  static backofficeUrl: string;
  static globalDataApi: string;
  static reportsUrl: string;
  static egxUrl: string;
  static appKey: string;
  static supportNumber: string;
  static companyName: string;
  static idleTime: number;
  static navButtonColor: string;
  static newSignalR: string;
  static landingNavButtonColor: string;
  static hasTechnicalAnalysis: boolean;
  static isEGID: boolean;
  static logoLink: string;
  static enableIPO: boolean;
  static enableMutualFund: boolean;
  static hasFundmentalAnalysis:boolean;
}
